import { render, staticRenderFns } from "./PartyBuildingTestList.vue?vue&type=template&id=ce551c74&"
import script from "./PartyBuildingTestList.vue?vue&type=script&lang=js&"
export * from "./PartyBuildingTestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports